import styled, { css } from 'styled-components';

export const LoginContainer = styled.form`
  position: relative;
  padding: 0 16px 80px;
`;

export const OtpImage = styled.img`
  width: 360px;
  height: auto;
  margin: 16px 0 8px;
`;

export const EasyDelivery = styled.p`
  color: hsl(0deg, 0%, 0%, 80%);
  font-weight: 500;
  padding: 12px 0;
  max-width: 360px;
  margin: 0 auto;
  text-align: left;
`;

export const ShieldSection = styled.div`
  display: flex;
  max-width: 360px;
  margin: 2px auto auto;
  padding: 9px 12px 8px 7px;
  border-radius: 4px;
  background-color: #f4f4f4;

  img {
    width: 17px;
    height: 20px;
    align-self: center;
  }

  p {
    font-size: 12px;
    font-weight: 300;
    text-align: left;
    padding-left: 8px;
    color: hsl(0deg, 0%, 0%, 80%);
  }
`;

export const InputSection = styled.div`
  max-width: 360px;
  margin: 0 auto;
  text-align: left;
  padding: 16px 0 8px;
`;

export const InputField = styled.div`
  border: 1px solid #ccc;
  border-radius: 6px;
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
  margin-top: 10px;

  input {
    width: ${(props) => (props.otp ? '97%' : '70%')};
    outline: none;
    height: ${(props) => (props.otp ? '38px' : '42px')};
    border: none;
    padding-left: 8px;
    font-family: 'Montserrat';

    &:focus {
      outline: none;
    }
    ${(props) =>
      props.readOnly &&
      css`
        background-color: #dddddd;
        opacity: 0.4;
      `}
  }

  span {
    padding: 0 8px;
    border-right: 1px solid #ccc;
  }
`;
export const InputFieldLogin = styled.div`
  position: relative;
  background-color: #fff;
  height: 56px;
  line-height: 56px;
  display: flex;
  align-items: center;
  margin-top: 10px;

  input {
    width: 100%;
    outline: none;
    height: 56px;
    border: ${(props) =>
      props.redBorder
        ? 'solid 1px #ef4e5e'
        : props.greenBorder
          ? 'solid 1px #63b0a8'
          : 'solid 1px #9e9e9e'};
    border-radius: 8px;
    padding-left: 8px;
    font-family: 'Montserrat';
    caret-color: #ef4e5e;
    font-size: 16px;
    &:focus {
      outline: none;
    }
    ${(props) =>
      props.readOnly &&
      css`
        background-color: #dddddd;
        opacity: 0.4;
        width: 100%;
      `}
  }

  span {
    padding: 0 8px;
    border-right: 1px solid #ccc;
    font-size: 16px;
  }

  .countryCode {
    border: ${(props) =>
      props.redBorder
        ? 'solid 1px #ef4e5e'
        : props.greenBorder
          ? 'solid 1px #63b0a8'
          : 'solid 1px #9e9e9e'};
    border-radius: 8px;
    padding: 0 12px;
    font-size: 16px;
    height: 56px;
    display: flex;
    align-items: center;
    background-color: #fff;
    margin-right: 8px;
  }

  @media (max-width: 720px) {
    width: 100%;
  }
`;
export const LoginButton = styled.button`
  width: 100%;
  background-color: #ef4e5e;
  color: #fff;
  position: absolute;
  bottom: 0;
  border: none;
  outline: none;
  left: 0;
  text-align: center;
  height: 42px;
  line-height: 42px;
  margin-top: 10px;
  font-size: 15px;
  font-weight: 500;
  font-family: 'Montserrat';
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
  overflow: hidden;
  @media (min-width: 720px) {
    cursor: pointer;
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;

export const ErrorText = styled.div`
  color: red;
  text-align: left;
  font-size: 14px;
  max-width: 360px;
  padding-top: 3px;
  opacity: ${(props) => (props.show ? '1' : '0')};
`;

export const EditSection = styled.div`
  display: flex;
  max-width: 360px;
  align-items: center;
  margin: 0 auto;

  .number {
    color: #707070;
    padding-right: 16px;
  }

  .edit {
    color: #ef4e5e;
    cursor: pointer;
    font-weight: 500;
  }
`;

export const WhiteCross = styled.img`
  position: absolute;
  width: 22px;
  right: 8px;
  top: -111px;
  @media (max-width: 720px) {
    cursor: pointer;
  }
`;

export const ResendIn = styled.div`
  max-width: 360px;
  color: #63b0a8;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  cursor: pointer;
  padding-top: 6px;
  font-weight: 500;

  span {
    padding-right: 4px;
  }
`;

export const LoginTitle = styled.div`
  position: absolute;
  top: -105px;
  color: #fff;
  font-weight: 500;
`;
